(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ds-content-2026"] && !Shopify.designMode) return;
  try {
    
(function(){
  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('on');io.unobserve(e.target);}});},{threshold:.15});
  document.querySelectorAll('.ds26-content-wrap .ds26-reveal2').forEach(function(el){ if(reduced){el.classList.add('on');} else {io.observe(el);} });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ds-flightlab-2026"] && !Shopify.designMode) return;
  try {
    
(function(){
  var v=document.querySelector('.dsfl-mark-v');
  if(v){
    if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches){
      v.removeAttribute('loop'); v.pause();
    }
    var swapped=false;
    var swap=function(){
      if(swapped||!v.parentNode)return;
      var url=v.getAttribute('data-fallback');
      if(!url)return;
      swapped=true;
      var img=document.createElement('img');
      img.className='dsfl-mark-i'; img.src=url; img.alt='';
      img.setAttribute('aria-hidden','true'); img.loading='lazy';
      v.parentNode.replaceChild(img,v);
    };
    v.addEventListener('error',swap,true);
    setTimeout(function(){ if(!v.videoWidth||v.readyState<2) swap(); },2600);
  }
  var thumbs=[].slice.call(document.querySelectorAll('.dsfl-thumb'));
  var lb=document.getElementById('dsfl-lb');
  if(!thumbs.length||!lb||lb.dataset.init)return;
  lb.dataset.init="1";
  var img=lb.querySelector('.dsfl-lb-img');
  var fulls=thumbs.map(function(t){return t.dataset.full;});
  var cur=0;
  function show(i){cur=(i+fulls.length)%fulls.length;img.src=fulls[cur];}
  function open(i){show(i);lb.hidden=false;document.documentElement.style.overflow='hidden';}
  function close(){lb.hidden=true;img.src='';document.documentElement.style.overflow='';}
  thumbs.forEach(function(t,i){t.addEventListener('click',function(){open(i);});});
  lb.querySelector('.dsfl-lb-x').addEventListener('click',close);
  lb.querySelector('.dsfl-lb-prev').addEventListener('click',function(e){e.stopPropagation();show(cur-1);});
  lb.querySelector('.dsfl-lb-next').addEventListener('click',function(e){e.stopPropagation();show(cur+1);});
  lb.addEventListener('click',function(e){if(e.target===lb)close();});
  document.addEventListener('keydown',function(e){
    if(lb.hidden)return;
    if(e.key==='Escape')close();
    if(e.key==='ArrowLeft')show(cur-1);
    if(e.key==='ArrowRight')show(cur+1);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ds-produkte-2026"] && !Shopify.designMode) return;
  try {
    
(function(){
  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('on');io.unobserve(e.target);}});},{threshold:.15});
  document.querySelectorAll('.ds26-produkte-wrap .ds26-reveal3').forEach(function(el){ if(reduced){el.classList.add('on');} else {io.observe(el);} });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ds-stories-2026"] && !Shopify.designMode) return;
  try {
    
(function(){
  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('on');io.unobserve(e.target);}});},{threshold:.18});
  document.querySelectorAll('.ds26-stories-wrap .ds26-reveal').forEach(function(el){ if(reduced){el.classList.add('on');} else {io.observe(el);} });
  var cio = new IntersectionObserver(function(es){es.forEach(function(e){
    if(!e.isIntersecting) return;
    var el = e.target, raw = el.textContent.trim(), m = raw.match(/^\d+$/);
    cio.unobserve(el);
    if(!m || reduced) return;
    var to = parseInt(raw,10), t0 = performance.now(), dur = 1400;
    (function tick(t){var p = Math.min((t-t0)/dur,1); el.textContent = Math.round(to*(1-Math.pow(1-p,3))); if(p<1) requestAnimationFrame(tick);})(t0);
  });},{threshold:.6});
  document.querySelectorAll('.ds26-stories-wrap .ds26-count').forEach(function(el){ cio.observe(el); });
  var st = document.querySelector('[data-ds26-statement]');
  if(st && !reduced){
    (function walk(n){ Array.prototype.slice.call(n.childNodes).forEach(function(c){
      if(c.nodeType === 3){
        var frag = document.createDocumentFragment();
        c.textContent.split(/(\s+)/).forEach(function(tk){
          if(tk.trim()){ var s = document.createElement('span'); s.className='ds26-w'; s.textContent = tk; frag.appendChild(s); }
          else frag.appendChild(document.createTextNode(tk));
        });
        n.replaceChild(frag, c);
      } else if(c.nodeType === 1) walk(c);
    });})(st);
    var words = st.querySelectorAll('.ds26-w');
    addEventListener('scroll', function(){
      var r = st.getBoundingClientRect();
      var p = Math.min(Math.max((innerHeight*.82 - r.top)/(r.height + innerHeight*.35),0),1);
      var k = Math.floor(p*words.length);
      words.forEach(function(w,idx){ w.classList.toggle('on', idx < k); });
    }, {passive:true});
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
